/** API Core */
export const coreOnboardingRoute = `virtual/onboarding`;
export const coreOnboardingJobCategoriesRoute = `virtual/onboarding/jobcat`;
